import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { FacePercentageItem } from '../models/face-percentage-model';
import { HelpersService } from './helpers.service';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  constructor(
    private httpClient: HttpClient
  ) { }

  async getFacePercentage(
    imageB64Data: string
  ): Promise<FacePercentageItem> {

    const endPoint = "https://xbthpjuqz3.execute-api.ap-south-1.amazonaws.com/face-percentage-python-v2"
    const body = { "image_b64": imageB64Data }

    return this.httpClient.post(endPoint, body)
      .pipe(
        map((response: any) => {

          const rawData = response.data

          return new FacePercentageItem(
            rawData["blur_percentage"],
            rawData["face_angle_diff"],
            rawData["face_height"],
            rawData["face_percentage"],
            rawData["face_width"],
            rawData["face_x"],
            rawData["face_y"],
            rawData["image_height"],
            rawData["image_width"],
            rawData["left_eye_ratio"],
            rawData["right_eye_ratio"],
            rawData["face_angle_l_diff"],
            rawData["face_angle_r_diff"],
            rawData["nose_x"],
            rawData["nose_y"],
            rawData["chin_x"],
            rawData["chin_y"],
          )

        })
      ).toPromise()

  }

}
